module.exports = __webpack_public_path__ + "static/media/itau.374bda9f.png";